import { getClickQuadrant } from '../../../library';
// TODO: remove
// export function generateContentCoords(triggerElement: HTMLElement, contentElement: HTMLDivElement): IContentCoords {
//   const triggerRect = triggerElement.getBoundingClientRect();
//   const triggerQuadrant = getClickQuadrant({ clientX: triggerRect.x, clientY: triggerRect.y });
//   let contentCoords: IContentCoords = { left: 0, top: 0 };
//   if (triggerQuadrant.x === 'left') contentCoords.left = triggerRect.right;
//   if (triggerQuadrant.x === 'right') contentCoords.left = triggerRect.left - contentElement.offsetWidth;
//   if (triggerQuadrant.y === 'top') contentCoords.top = triggerRect.bottom;
//   if (triggerQuadrant.y === 'bottom') contentCoords.top = triggerRect.top - contentElement.offsetHeight;
//   return contentCoords;
// }
export function generateContentCoords(event, contentElement) {
    var eventQuadrant = getClickQuadrant(event);
    var contentCoords = {
        top: eventQuadrant.y === 'top' ? event.clientY : event.clientY - contentElement.offsetHeight,
        left: eventQuadrant.x === 'left' ? event.clientX : event.clientX - contentElement.offsetWidth,
    };
    return contentCoords;
}
